import { useTranslation } from 'react-i18next';

import { FormLayout } from 'components/form/formLayout/formLayout';
import IconCopy from 'components/icons/copy';

import { LABELS, ONBOARDING_LABELS } from '../keys';
import { CheckIcon, CopyButton, Link, Row } from '../styles';

interface OnboardingPanelProps {
  onboardingToken: string | null;
  allTosAccepted: boolean;
}

export const OnboardingPanel = ({ onboardingToken, allTosAccepted }: OnboardingPanelProps) => {
  const { t } = useTranslation();

  if (allTosAccepted) {
    return (
      <FormLayout
        fields={[
          {
            key: t(ONBOARDING_LABELS.PANEL_FIELDS.TOS_PAGE),
            label: t(ONBOARDING_LABELS.PANEL_FIELDS.TOS_PAGE),
            renderInput: () => (
              <Row>
                <CheckIcon />
                {t(ONBOARDING_LABELS.PANEL_VALUES.ALL_ACCEPTED)}
              </Row>
            ),
          },
        ]}
      />
    );
  }

  // eslint-disable-next-line no-undef
  const appGlobal = globalThis as unknown as Window;
  const tosLink = `${appGlobal.s4cConfig.corWidgetUrl}pay/onboarding/${onboardingToken}`;

  const copyText = async () => {
    await navigator.clipboard.writeText(tosLink);
  };

  return (
    <FormLayout
      fields={[
        {
          key: t(ONBOARDING_LABELS.PANEL_FIELDS.TOS_PAGE),
          label: t(ONBOARDING_LABELS.PANEL_FIELDS.TOS_PAGE),
          valueLabelWidth: 'auto',
          renderInput: () => (
            <Row>
              <Link target="_blank" to={tosLink}>
                {tosLink}
              </Link>{' '}
              <CopyButton secondary flat onClick={copyText}>
                <IconCopy />
                {t(LABELS.SECTIONS.COPY_BUTTON_LABEL)}
              </CopyButton>
            </Row>
          ),
        },
      ]}
    />
  );
};
